import React, { lazy } from 'react';
import { PageNotFound } from '@/layout/common-pages';
import ProtectedRoute from '@/router/components/ProtectedRoute';
import { ROUTES } from '@/constants/routes';

// Lazy loaded components
const ReleasePage = lazy(() => import('@/pages/releases'));
const ReleaseDashboardPage = lazy(() => import('@/pages/releases/dashboard'));
const ReleaseCalendarPage = lazy(() => import('@/pages/releases/calendar'));
const ReleaseDetailsView = lazy(
  () => import('@/pages/releases/release-list/details'),
);
const ReleaseSupportDashboard = lazy(() => import('@/pages/releases/support'));
const ReleaseTestCasesDashboard = lazy(
  () => import('@/pages/release-test-cases'),
);

const ReleasePivotReport = lazy(
  () => import('@/pages/releases/release-pivot-report'),
);

/**
 * Release management routes configuration
 */
export const releaseRoutes = [
  {
    path: ROUTES.RELEASE_DASHBOARD,
    element: <ProtectedRoute component={ReleaseDashboardPage} />,
  },
  {
    path: ROUTES.RELEASE_SUPPORT,
    element: <ProtectedRoute component={ReleaseSupportDashboard} />,
  },
  {
    path: ROUTES.RELEASE_CALENDAR,
    element: <ProtectedRoute component={ReleaseCalendarPage} />,
  },
  {
    path: ROUTES.RELEASE_LIST,
    element: <ProtectedRoute component={ReleasePage} />,
    children: [
      {
        path: ROUTES.RELEASE_DETAILS,
        element: <ProtectedRoute component={ReleaseDetailsView} />,
      },
      {
        path: ROUTES.RELEASE_DETAILS_NO_DATA,
        element: <PageNotFound />,
      },
    ],
  },
  {
    path: ROUTES.RELEASE_TEST_CASES,
    element: <ProtectedRoute component={ReleaseTestCasesDashboard} />,
  },
  {
    path: ROUTES.RELEASE_PIVOT_REPORT,
    element: <ProtectedRoute component={ReleasePivotReport} />,
  },
];
